export const QUESTION_CHANGE_ANIMATION_TIME_IN_MS = 300;
